import React from 'react'

export const Hint = ({type, text, hidden}) => {
  return hidden ? null : <div className={`hint ${type}`}>{text}</div>
}
